export const clickNavBar = [
  {
    text: "url-click",
    icon: "mdi-hand-pointing-up",
    to: "/post-file-click",
  },
];
